var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-handsel"},[_c('img',{attrs:{"src":require("@/assets/img/personalCenter/user-handsel.png"),"alt":""}}),_c('p',[_vm._v("定金单不属于当前登录用户，请核实后再操作哦！")]),_c('button',{on:{"click":_vm.toHome}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }